'use strict';

!function ($) {

  /**
   * Toggler module.
   * @module foundation.toggler
   * @requires foundation.util.motion
   * @requires foundation.util.triggers
   */

  class Toggler {
    /**
     * Creates a new instance of Toggler.
     * @class
     * @fires Toggler#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */
    constructor(element, options) {
      this.$element = element;
      this.options = $.extend({}, Toggler.defaults, element.data(), options);
      this.className = '';

      this._init();
      this._events();

      Foundation.registerPlugin(this, 'Toggler');
    }

    /**
     * Initializes the Toggler plugin by parsing the toggle class from data-toggler, or animation classes from data-animate.
     * @function
     * @private
     */
    _init() {
      var input;
      if (this.options.animate) {
        input = this.options.animate.split(' ');

        this.animationIn = input[0];
        this.animationOut = input[1] || null;
      } else {
        input = this.$element.data('toggler');
        this.className = input[0] === '.' ? input.slice(1) : input;
      }

      var id = this.$element[0].id;
      $(`[data-open="${id}"], [data-close="${id}"], [data-toggle="${id}"]`)
        .attr('aria-controls', id);
      this.$element.attr('aria-expanded', this.$element.is(':hidden') ? false : true);
    }

    _events() {
      this.$element.off('toggle.zf.trigger').on('toggle.zf.trigger', this.toggle.bind(this));
    }

    toggle() {
      this[this.options.animate ? '_toggleAnimate' : '_toggleClass']();
    }

    _toggleClass() {
      this.$element.toggleClass(this.className);

      const targetSelector = this.$element.data('togglerTarget');
      if (targetSelector) {
        const $targetElement = $(targetSelector);
        $targetElement.toggleClass(this.className);
      }

      const isOn = this.$element.hasClass(this.className);
      if (isOn) {
        this.$element.trigger('on.zf.toggler');
      } else {
        this.$element.trigger('off.zf.toggler');
      }

      this._updateARIA(isOn);
    }

    _toggleAnimate() {
      var _this = this;

      if (this.$element.is(':hidden')) {
        Foundation.Motion.animateIn(this.$element, this.animationIn, function () {
          _this._updateARIA(true);
          this.trigger('on.zf.toggler');
        });
      } else {
        Foundation.Motion.animateOut(this.$element, this.animationOut, function () {
          _this._updateARIA(false);
          this.trigger('off.zf.toggler');
        });
      }
    }

    _updateARIA(isOn) {
      this.$element.attr('aria-expanded', isOn ? true : false);
    }

    destroy() {
      this.$element.off('.zf.toggler');
      Foundation.unregisterPlugin(this);
    }
  }

  Toggler.defaults = {
    animate: false
  };

  // Register the Toggler plugin with Foundation
  Foundation.plugin(Toggler, 'Toggler');

  // Initialize Custom Toggler
  $(document).on('click', '[data-toggler-target]', function () {
    const targets = $(this).data('togglerTarget').split(',').map(selector => selector.trim());
    targets.forEach(target => {
      $(target).toggleClass('is-hidden');
    });
  });

}(jQuery);
